import { useEffect, useState } from 'react';

/**
 * Returns a copy of `value` that only updates after it has stayed unchanged for `delayMs`.
 * Handy for throttling a fast-changing input (e.g. a search box) before it drives a query.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
